import React, { forwardRef } from "react";
const SvgPlayerPlayFilled = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 4v16a1 1 0 0 0 1.524.852l13-8a1 1 0 0 0 0-1.704l-13-8A1 1 0 0 0 6 4Z" }));
const ForwardRef = forwardRef(SvgPlayerPlayFilled);
export default ForwardRef;
